import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SltAddDataServiceService {

  constructor(private http: HttpClient) { }

  /**
   * Get list of all clients
   * @param adminApiUrl - The admin API URL (GENERAL_CONFIG.admin_api_url)
   * @returns Observable with client list data
   */
  getAllClients(adminApiUrl: string): Observable<any> {
    // MATCHES AngularJS ClientAdminFactory.getAllClients()
    // URL: GENERAL_CONFIG.admin_api_url + '/getAllClients'
    // Method: POST
    const url = `${adminApiUrl}/getAllClients`;
    
    return this.http.post<any>(url, {}, { 
      withCredentials: true 
    });
  }

  /**
   * Get clients assigned to a specific data service
   * @param baseUrl - The base URL for API calls
   * @param serviceKey - The SERVICE_KEY to fetch assigned clients for
   * @returns Observable with data service client assignments
   */
  getDataServiceClients(baseUrl: string, serviceKey: string | number): Observable<any> {
    // Following the AngularJS pattern with action_id=32804
    const url = `${baseUrl}/loadJsonObject?action_id=32804&service_key=${serviceKey}`;
    
    return this.http.get<any>(url, { 
      withCredentials: true 
    });
  }

  /**
   * Save data service (create or update)
   * @param baseUrl - The base URL for API calls
   * @param serviceData - The service data to save
   * @returns Observable with save operation response
   */
  saveDataService(baseUrl: string, serviceData: any): Observable<any> {
    // Following the AngularJS pattern with action_code=vzpu0u
    const url = `${baseUrl}/saveJsonObject?action_code=vzpu0u`;
    
    // Build URL-encoded parameters
    const urlEncoded = new URLSearchParams();
    Object.keys(serviceData).forEach(key => {
      if (serviceData[key] !== undefined && serviceData[key] !== null) {
        urlEncoded.set(key, serviceData[key].toString());
      }
    });
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    
    return this.http.post<any>(url, urlEncoded.toString(), { 
      headers, 
      withCredentials: true 
    });
  }
}


